import React from 'react';
import PolicyPage from '../PolicyPage';

/** Platform car sharing agreement (spec 031). The static file is the fallback once it is exported. */
const CarSharingAgreementPage: React.FC = () => (
  <PolicyPage
    title="Car Sharing Agreement"
    contentPath="/policies/car-sharing-agreement.md"
    kind="CAR_SHARING_AGREEMENT"
  />
);

export default CarSharingAgreementPage;
